//Reviewed
import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import Login from "../../Components/Login/Login";
import Footer from "../../Components/Common/Footer";

class LoginPage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <Login />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default LoginPage;
